module.exports = __webpack_public_path__ + "img/dynamic3.ee3d2858.jpg";